import {
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  Stack,
  Box,
} from '@chakra-ui/react'
import React from 'react'

const txt = `歡迎使用由真實引擎股份有限公司（以下簡稱「真實引擎」、「本公司」）負責營運之 Portaly 傳送門(portaly.cc) 網站服務（以下稱為「本網站」、「本服務」)。

當訪客（以下稱為「您」、「使用者」、「用戶」、「支持者」）使用本網站時，即表示您已閱讀此聲明並表示同意，如您有違反本服務條款之行為，本公司可依據相關規則暫停或終止您使用本網站之服務。若您不同意本條款之部分或全部內容，您應立即停止使用本網站。

任何使用者於使用本網站服務時，需先詳讀本條款與隱私權政策，或其他本網站未來陸續公布之相關條款。請您確實遵守上列條款與中華民國法律，若您無法確實遵守本條款內容，或對於本條款內容全部或部分不同意時，請勿使用本網站服務。

若使用者未滿二十歲，除應符合上述規定外，須保證其獲得法定代理人同意可使用 本網站提供的服務。當該使用者申請註冊成為會員，並繼續使用 本網站提供的服務時，則表示其法定代理人已經閱讀且知悉並同意本條款。

1. 條款更新與修改
真實引擎在法律准許的範圍內，有權隨時修改、調整本條款中的任何條款內容。當您使用本網站特定服務或新增功能時，可能會依據該特定服務之性質，而須遵守真實引擎所另行公告之服務條款或相關規定。此另行公告之服務條款或相關規定，亦均併入屬於本服務條款之一部分，本服務條款規範您對於本網站所提供之服務的使用行為。如果您在修改發布後，繼續使用真實引擎所提供的所有服務，則表示您同意遵守對本條款所作出的該等修改。如果您不同意真實引擎對本條款進行的修改，請您立即停止使用本網站服務。

2. 遵守法律
使用真實引擎服務時，您必須遵守中華民國法律。無論您的身分為訪客或註冊使用者，您只有在同意遵守所有適用的相關法律法規和本條款時，才有權使用真實引擎服務。

3. 隱私權政策
使用者提供的個人資料及真實引擎保存與使用者相關之資料，將受到中華民國法律和真實引擎隱私權政策之規範。

4. 贊助支持
「贊助支持」並非之「公益勸募」，創作者將提供包含手機桌布、插圖、e-mail 信件等「數位回饋」，並由本公司將開立統一發票。

5. 鑑賞期
本贊助系統服務適用「七天鑑賞期」之網路消費規範。使用者有權於贊助七日內申請退款。如欲退款之情形，請寄信至 service@portaly.cc

6. 匿名贊助
您瞭解如果選擇匿名方式贊助或選擇捐贈發票，可能導致您無法主張包括鑑賞期、退款等相關權利。
`

const Terms = () => {
  const { isOpen, onClose, onOpen } = useDisclosure()
  return (
    <>
      <Box textAlign="center">
        <Button colorScheme="primary" variant="link" onClick={onOpen}>使用條款</Button>
      </Box>
      <Modal isOpen={isOpen} onClose={onClose} size="3xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Portaly 傳送門「贊助支持」使用條款</ModalHeader>
          <ModalCloseButton />
          <ModalBody as={Stack} spacing={2}>
            {txt.split('\n').map((t, i) => (
              <Text key={i} textAlign="justify">{t}</Text>
            ))}
          </ModalBody>

          <ModalFooter justifyContent="center">
            <Button colorScheme="primary" onClick={onClose}>
              關閉
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}

export default Terms
